// ===========================================
// konakla - Türkiye Şehir ve İlçe Verileri
// Kaynak: turkiye-api (https://github.com/ubeydeozdmr/turkiye-api.git)
// ===========================================

export interface City {
  id: number;
  name: string;
  districts: string[];
}

// Türkiye'nin 81 ili ve ilçeleri — PLAKA SIRASINDA (alfabetik DEĞİL).
// `city.id` = plaka kodu ve lib/import/location.ts buna güveniyor; diziyi
// yeniden sıralama. Tüketiciler aranabilir CityCombobox kullandığı için
// liste sırasının kullanıcıya etkisi yok.
export const TURKEY_CITIES: City[] = [
  {
    id: 1,
    name: "Adana",
    districts: [
      "Aladağ",
      "Ceyhan",
      "Çukurova",
      "Feke",
      "İmamoğlu",
      "Karaisalı",
      "Karataş",
      "Kozan",
      "Pozantı",
      "Saimbeyli",
      "Sarıçam",
      "Seyhan",
      "Tufanbeyli",
      "Yumurtalık",
      "Yüreğir",
    ],
  },
  {
    id: 2,
    name: "Adıyaman",
    districts: [
      "Besni",
      "Çelikhan",
      "Gerger",
      "Gölbaşı",
      "Kahta",
      "Merkez",
      "Samsat",
      "Sincik",
      "Tut",
    ],
  },
  {
    id: 3,
    name: "Afyonkarahisar",
    districts: [
      "Başmakçı",
      "Bayat",
      "Bolvadin",
      "Çay",
      "Çobanlar",
      "Dazkırı",
      "Dinar",
      "Emirdağ",
      "Evciler",
      "Hocalar",
      "İhsaniye",
      "İscehisar",
      "Kızılören",
      "Merkez",
      "Sandıklı",
      "Sinanpaşa",
      "Sultandağı",
      "Şuhut",
    ],
  },
  {
    id: 4,
    name: "Ağrı",
    districts: [
      "Diyadin",
      "Doğubayazıt",
      "Eleşkirt",
      "Hamur",
      "Merkez",
      "Patnos",
      "Taşlıçay",
      "Tutak",
    ],
  },
  {
    id: 5,
    name: "Amasya",
    districts: ["Göynücek", "Gümüşhacıköy", "Hamamözü", "Merkez", "Merzifon", "Suluova", "Taşova"],
  },
  {
    id: 6,
    name: "Ankara",
    districts: [
      "Akyurt",
      "Altındağ",
      "Ayaş",
      "Balâ",
      "Beypazarı",
      "Çamlıdere",
      "Çankaya",
      "Çubuk",
      "Elmadağ",
      "Etimesgut",
      "Evren",
      "Gölbaşı",
      "Güdül",
      "Haymana",
      "Kahramankazan",
      "Kalecik",
      "Keçiören",
      "Kızılcahamam",
      "Mamak",
      "Nallıhan",
      "Polatlı",
      "Pursaklar",
      "Sincan",
      "Şereflikoçhisar",
      "Yenimahalle",
    ],
  },
  {
    id: 7,
    name: "Antalya",
    districts: [
      "Akseki",
      "Aksu",
      "Alanya",
      "Demre",
      "Döşemealtı",
      "Elmalı",
      "Finike",
      "Gazipaşa",
      "Gündoğmuş",
      "İbradı",
      "Kaş",
      "Kemer",
      "Kepez",
      "Konyaaltı",
      "Korkuteli",
      "Kumluca",
      "Manavgat",
      "Muratpaşa",
      "Serik",
    ],
  },
  {
    id: 8,
    name: "Artvin",
    districts: [
      "Ardanuç",
      "Arhavi",
      "Borçka",
      "Hopa",
      "Kemalpaşa",
      "Merkez",
      "Murgul",
      "Şavşat",
      "Yusufeli",
    ],
  },
  {
    id: 9,
    name: "Aydın",
    districts: [
      "Bozdoğan",
      "Buharkent",
      "Çine",
      "Didim",
      "Efeler",
      "Germencik",
      "İncirliova",
      "Karacasu",
      "Karpuzlu",
      "Koçarlı",
      "Köşk",
      "Kuşadası",
      "Kuyucak",
      "Nazilli",
      "Söke",
      "Sultanhisar",
      "Yenipazar",
    ],
  },
  {
    id: 10,
    name: "Balıkesir",
    districts: [
      "Altıeylül",
      "Ayvalık",
      "Balya",
      "Bandırma",
      "Bigadiç",
      "Burhaniye",
      "Dursunbey",
      "Edremit",
      "Erdek",
      "Gömeç",
      "Gönen",
      "Havran",
      "İvrindi",
      "Karesi",
      "Kepsut",
      "Manyas",
      "Marmara",
      "Savaştepe",
      "Sındırgı",
      "Susurluk",
    ],
  },
  {
    id: 11,
    name: "Bilecik",
    districts: [
      "Bozüyük",
      "Gölpazarı",
      "İnhisar",
      "Merkez",
      "Osmaneli",
      "Pazaryeri",
      "Söğüt",
      "Yenipazar",
    ],
  },
  {
    id: 12,
    name: "Bingöl",
    districts: ["Adaklı", "Genç", "Karlıova", "Kiğı", "Merkez", "Solhan", "Yayladere", "Yedisu"],
  },
  {
    id: 13,
    name: "Bitlis",
    districts: ["Adilcevaz", "Ahlat", "Güroymak", "Hizan", "Merkez", "Mutki", "Tatvan"],
  },
  {
    id: 14,
    name: "Bolu",
    districts: [
      "Dörtdivan",
      "Gerede",
      "Göynük",
      "Kıbrıscık",
      "Mengen",
      "Merkez",
      "Mudurnu",
      "Seben",
      "Yeniçağa",
    ],
  },
  {
    id: 15,
    name: "Burdur",
    districts: [
      "Ağlasun",
      "Altınyayla",
      "Bucak",
      "Çavdır",
      "Çeltikçi",
      "Gölhisar",
      "Karamanlı",
      "Kemer",
      "Merkez",
      "Tefenni",
      "Yeşilova",
    ],
  },
  {
    id: 16,
    name: "Bursa",
    districts: [
      "Büyükorhan",
      "Gemlik",
      "Gürsu",
      "Harmancık",
      "İnegöl",
      "İznik",
      "Karacabey",
      "Keles",
      "Kestel",
      "Mudanya",
      "Mustafakemalpaşa",
      "Nilüfer",
      "Orhaneli",
      "Orhangazi",
      "Osmangazi",
      "Yenişehir",
      "Yıldırım",
    ],
  },
  {
    id: 17,
    name: "Çanakkale",
    districts: [
      "Ayvacık",
      "Bayramiç",
      "Biga",
      "Bozcaada",
      "Çan",
      "Eceabat",
      "Ezine",
      "Gelibolu",
      "Gökçeada",
      "Lapseki",
      "Merkez",
      "Yenice",
    ],
  },
  {
    id: 18,
    name: "Çankırı",
    districts: [
      "Atkaracalar",
      "Bayramören",
      "Çerkeş",
      "Eldivan",
      "Ilgaz",
      "Kızılırmak",
      "Korgun",
      "Kurşunlu",
      "Merkez",
      "Orta",
      "Şabanözü",
      "Yapraklı",
    ],
  },
  {
    id: 19,
    name: "Çorum",
    districts: [
      "Alaca",
      "Bayat",
      "Boğazkale",
      "Dodurga",
      "İskilip",
      "Kargı",
      "Laçin",
      "Mecitözü",
      "Merkez",
      "Oğuzlar",
      "Ortaköy",
      "Osmancık",
      "Sungurlu",
      "Uğurludağ",
    ],
  },
  {
    id: 20,
    name: "Denizli",
    districts: [
      "Acıpayam",
      "Babadağ",
      "Baklan",
      "Bekilli",
      "Beyağaç",
      "Bozkurt",
      "Buldan",
      "Çal",
      "Çameli",
      "Çardak",
      "Çivril",
      "Güney",
      "Honaz",
      "Kale",
      "Merkezefendi",
      "Pamukkale",
      "Sarayköy",
      "Serinhisar",
      "Tavas",
    ],
  },
  {
    id: 21,
    name: "Diyarbakır",
    districts: [
      "Bağlar",
      "Bismil",
      "Çermik",
      "Çınar",
      "Çüngüş",
      "Dicle",
      "Eğil",
      "Ergani",
      "Hani",
      "Hazro",
      "Kayapınar",
      "Kocaköy",
      "Kulp",
      "Lice",
      "Silvan",
      "Sur",
      "Yenişehir",
    ],
  },
  {
    id: 22,
    name: "Edirne",
    districts: [
      "Enez",
      "Havsa",
      "İpsala",
      "Keşan",
      "Lalapaşa",
      "Meriç",
      "Merkez",
      "Süloğlu",
      "Uzunköprü",
    ],
  },
  {
    id: 23,
    name: "Elazığ",
    districts: [
      "Ağın",
      "Alacakaya",
      "Arıcak",
      "Baskil",
      "Karakoçan",
      "Keban",
      "Kovancılar",
      "Maden",
      "Merkez",
      "Palu",
      "Sivrice",
    ],
  },
  {
    id: 24,
    name: "Erzincan",
    districts: [
      "Çayırlı",
      "İliç",
      "Kemah",
      "Kemaliye",
      "Merkez",
      "Otlukbeli",
      "Refahiye",
      "Tercan",
      "Üzümlü",
    ],
  },
  {
    id: 25,
    name: "Erzurum",
    districts: [
      "Aşkale",
      "Aziziye",
      "Çat",
      "Hınıs",
      "Horasan",
      "İspir",
      "Karaçoban",
      "Karayazı",
      "Köprüköy",
      "Narman",
      "Oltu",
      "Olur",
      "Palandöken",
      "Pasinler",
      "Pazaryolu",
      "Şenkaya",
      "Tekman",
      "Tortum",
      "Uzundere",
      "Yakutiye",
    ],
  },
  {
    id: 26,
    name: "Eskişehir",
    districts: [
      "Alpu",
      "Beylikova",
      "Çifteler",
      "Günyüzü",
      "Han",
      "İnönü",
      "Mahmudiye",
      "Mihalgazi",
      "Mihalıççık",
      "Odunpazarı",
      "Sarıcakaya",
      "Seyitgazi",
      "Sivrihisar",
      "Tepebaşı",
    ],
  },
  {
    id: 27,
    name: "Gaziantep",
    districts: [
      "Araban",
      "İslahiye",
      "Karkamış",
      "Nizip",
      "Nurdağı",
      "Oğuzeli",
      "Şahinbey",
      "Şehitkamil",
      "Yavuzeli",
    ],
  },
  {
    id: 28,
    name: "Giresun",
    districts: [
      "Alucra",
      "Bulancak",
      "Çamoluk",
      "Çanakçı",
      "Dereli",
      "Doğankent",
      "Espiye",
      "Eynesil",
      "Görele",
      "Güce",
      "Keşap",
      "Merkez",
      "Piraziz",
      "Şebinkarahisar",
      "Tirebolu",
      "Yağlıdere",
    ],
  },
  {
    id: 29,
    name: "Gümüşhane",
    districts: ["Kelkit", "Köse", "Kürtün", "Merkez", "Şiran", "Torul"],
  },
  {
    id: 30,
    name: "Hakkari",
    districts: ["Çukurca", "Derecik", "Merkez", "Şemdinli", "Yüksekova"],
  },
  {
    id: 31,
    name: "Hatay",
    districts: [
      "Altınözü",
      "Antakya",
      "Arsuz",
      "Belen",
      "Defne",
      "Dörtyol",
      "Erzin",
      "Hassa",
      "İskenderun",
      "Kırıkhan",
      "Kumlu",
      "Payas",
      "Reyhanlı",
      "Samandağ",
      "Yayladağı",
    ],
  },
  {
    id: 32,
    name: "Isparta",
    districts: [
      "Aksu",
      "Atabey",
      "Eğirdir",
      "Gelendost",
      "Gönen",
      "Keçiborlu",
      "Merkez",
      "Senirkent",
      "Sütçüler",
      "Şarkikaraağaç",
      "Uluborlu",
      "Yalvaç",
      "Yenişarbademli",
    ],
  },
  {
    id: 33,
    name: "Mersin",
    districts: [
      "Akdeniz",
      "Anamur",
      "Aydıncık",
      "Bozyazı",
      "Çamlıyayla",
      "Erdemli",
      "Gülnar",
      "Mezitli",
      "Mut",
      "Silifke",
      "Tarsus",
      "Toroslar",
      "Yenişehir",
    ],
  },
  {
    id: 34,
    name: "İstanbul",
    districts: [
      "Adalar",
      "Arnavutköy",
      "Ataşehir",
      "Avcılar",
      "Bağcılar",
      "Bahçelievler",
      "Bakırköy",
      "Başakşehir",
      "Bayrampaşa",
      "Beşiktaş",
      "Beykoz",
      "Beylikdüzü",
      "Beyoğlu",
      "Büyükçekmece",
      "Çatalca",
      "Çekmeköy",
      "Esenler",
      "Esenyurt",
      "Eyüpsultan",
      "Fatih",
      "Gaziosmanpaşa",
      "Güngören",
      "Kadıköy",
      "Kağıthane",
      "Kartal",
      "Küçükçekmece",
      "Maltepe",
      "Pendik",
      "Sancaktepe",
      "Sarıyer",
      "Silivri",
      "Sultanbeyli",
      "Sultangazi",
      "Şile",
      "Şişli",
      "Tuzla",
      "Ümraniye",
      "Üsküdar",
      "Zeytinburnu",
    ],
  },
  {
    id: 35,
    name: "İzmir",
    districts: [
      "Aliağa",
      "Balçova",
      "Bayındır",
      "Bayraklı",
      "Bergama",
      "Beydağ",
      "Bornova",
      "Buca",
      "Çeşme",
      "Çiğli",
      "Dikili",
      "Foça",
      "Gaziemir",
      "Güzelbahçe",
      "Karabağlar",
      "Karaburun",
      "Karşıyaka",
      "Kemalpaşa",
      "Kınık",
      "Kiraz",
      "Konak",
      "Menderes",
      "Menemen",
      "Narlıdere",
      "Ödemiş",
      "Seferihisar",
      "Selçuk",
      "Tire",
      "Torbalı",
      "Urla",
    ],
  },
  {
    id: 36,
    name: "Kars",
    districts: ["Akyaka", "Arpaçay", "Digor", "Kağızman", "Merkez", "Sarıkamış", "Selim", "Susuz"],
  },
  {
    id: 37,
    name: "Kastamonu",
    districts: [
      "Abana",
      "Ağlı",
      "Araç",
      "Azdavay",
      "Bozkurt",
      "Cide",
      "Çatalzeytin",
      "Daday",
      "Devrekani",
      "Doğanyurt",
      "Hanönü",
      "İhsangazi",
      "İnebolu",
      "Küre",
      "Merkez",
      "Pınarbaşı",
      "Seydiler",
      "Şenpazar",
      "Taşköprü",
      "Tosya",
    ],
  },
  {
    id: 38,
    name: "Kayseri",
    districts: [
      "Akkışla",
      "Bünyan",
      "Develi",
      "Felahiye",
      "Hacılar",
      "İncesu",
      "Kocasinan",
      "Melikgazi",
      "Özvatan",
      "Pınarbaşı",
      "Sarıoğlan",
      "Sarız",
      "Talas",
      "Tomarza",
      "Yahyalı",
      "Yeşilhisar",
    ],
  },
  {
    id: 39,
    name: "Kırklareli",
    districts: [
      "Babaeski",
      "Demirköy",
      "Kofçaz",
      "Lüleburgaz",
      "Merkez",
      "Pehlivanköy",
      "Pınarhisar",
      "Vize",
    ],
  },
  {
    id: 40,
    name: "Kırşehir",
    districts: ["Akçakent", "Akpınar", "Boztepe", "Çiçekdağı", "Kaman", "Merkez", "Mucur"],
  },
  {
    id: 41,
    name: "Kocaeli",
    districts: [
      "Başiskele",
      "Çayırova",
      "Darıca",
      "Derince",
      "Dilovası",
      "Gebze",
      "Gölcük",
      "İzmit",
      "Kandıra",
      "Karamürsel",
      "Kartepe",
      "Körfez",
    ],
  },
  {
    id: 42,
    name: "Konya",
    districts: [
      "Ahırlı",
      "Akören",
      "Akşehir",
      "Altınekin",
      "Beyşehir",
      "Bozkır",
      "Cihanbeyli",
      "Çeltik",
      "Çumra",
      "Derbent",
      "Derebucak",
      "Doğanhisar",
      "Emirgazi",
      "Ereğli",
      "Güneysınır",
      "Hadim",
      "Halkapınar",
      "Hüyük",
      "Ilgın",
      "Kadınhanı",
      "Karapınar",
      "Karatay",
      "Kulu",
      "Meram",
      "Sarayönü",
      "Selçuklu",
      "Seydişehir",
      "Taşkent",
      "Tuzlukçu",
      "Yalıhüyük",
      "Yunak",
    ],
  },
  {
    id: 43,
    name: "Kütahya",
    districts: [
      "Altıntaş",
      "Aslanapa",
      "Çavdarhisar",
      "Domaniç",
      "Dumlupınar",
      "Emet",
      "Gediz",
      "Hisarcık",
      "Merkez",
      "Pazarlar",
      "Şaphane",
      "Simav",
      "Tavşanlı",
    ],
  },
  {
    id: 44,
    name: "Malatya",
    districts: [
      "Akçadağ",
      "Arapgir",
      "Arguvan",
      "Battalgazi",
      "Darende",
      "Doğanşehir",
      "Doğanyol",
      "Hekimhan",
      "Kale",
      "Kuluncak",
      "Pütürge",
      "Yazıhan",
      "Yeşilyurt",
    ],
  },
  {
    id: 45,
    name: "Manisa",
    districts: [
      "Ahmetli",
      "Akhisar",
      "Alaşehir",
      "Demirci",
      "Gölmarmara",
      "Gördes",
      "Kırkağaç",
      "Köprübaşı",
      "Kula",
      "Salihli",
      "Sarıgöl",
      "Saruhanlı",
      "Selendi",
      "Soma",
      "Şehzadeler",
      "Turgutlu",
      "Yunusemre",
    ],
  },
  {
    id: 46,
    name: "Kahramanmaraş",
    districts: [
      "Afşin",
      "Andırın",
      "Çağlayancerit",
      "Dulkadiroğlu",
      "Ekinözü",
      "Elbistan",
      "Göksun",
      "Nurhak",
      "Onikişubat",
      "Pazarcık",
      "Türkoğlu",
    ],
  },
  {
    id: 47,
    name: "Mardin",
    districts: [
      "Artuklu",
      "Dargeçit",
      "Derik",
      "Kızıltepe",
      "Mazıdağı",
      "Midyat",
      "Nusaybin",
      "Ömerli",
      "Savur",
      "Yeşilli",
    ],
  },
  {
    id: 48,
    name: "Muğla",
    districts: [
      "Bodrum",
      "Dalaman",
      "Datça",
      "Fethiye",
      "Kavaklıdere",
      "Köyceğiz",
      "Marmaris",
      "Menteşe",
      "Milas",
      "Ortaca",
      "Seydikemer",
      "Ula",
      "Yatağan",
    ],
  },
  {
    id: 49,
    name: "Muş",
    districts: ["Bulanık", "Hasköy", "Korkut", "Malazgirt", "Merkez", "Varto"],
  },
  {
    id: 50,
    name: "Nevşehir",
    districts: [
      "Acıgöl",
      "Avanos",
      "Derinkuyu",
      "Gülşehir",
      "Hacıbektaş",
      "Kozaklı",
      "Merkez",
      "Ürgüp",
    ],
  },
  {
    id: 51,
    name: "Niğde",
    districts: ["Altunhisar", "Bor", "Çamardı", "Çiftlik", "Merkez", "Ulukışla"],
  },
  {
    id: 52,
    name: "Ordu",
    districts: [
      "Akkuş",
      "Altınordu",
      "Aybastı",
      "Çamaş",
      "Çatalpınar",
      "Çaybaşı",
      "Fatsa",
      "Gölköy",
      "Gülyalı",
      "Gürgentepe",
      "İkizce",
      "Kabadüz",
      "Kabataş",
      "Korgan",
      "Kumru",
      "Mesudiye",
      "Perşembe",
      "Ulubey",
      "Ünye",
    ],
  },
  {
    id: 53,
    name: "Rize",
    districts: [
      "Ardeşen",
      "Çamlıhemşin",
      "Çayeli",
      "Derepazarı",
      "Fındıklı",
      "Güneysu",
      "Hemşin",
      "İkizdere",
      "İyidere",
      "Kalkandere",
      "Merkez",
      "Pazar",
    ],
  },
  {
    id: 54,
    name: "Sakarya",
    districts: [
      "Adapazarı",
      "Akyazı",
      "Arifiye",
      "Erenler",
      "Ferizli",
      "Geyve",
      "Hendek",
      "Karapürçek",
      "Karasu",
      "Kaynarca",
      "Kocaali",
      "Pamukova",
      "Sapanca",
      "Serdivan",
      "Söğütlü",
      "Taraklı",
    ],
  },
  {
    id: 55,
    name: "Samsun",
    districts: [
      "Alaçam",
      "Asarcık",
      "Atakum",
      "Ayvacık",
      "Bafra",
      "Canik",
      "Çarşamba",
      "Havza",
      "İlkadım",
      "Kavak",
      "Ladik",
      "Ondokuzmayıs",
      "Salıpazarı",
      "Tekkeköy",
      "Terme",
      "Vezirköprü",
      "Yakakent",
    ],
  },
  {
    id: 56,
    name: "Siirt",
    districts: ["Baykan", "Eruh", "Kurtalan", "Merkez", "Pervari", "Şirvan", "Tillo"],
  },
  {
    id: 57,
    name: "Sinop",
    districts: [
      "Ayancık",
      "Boyabat",
      "Dikmen",
      "Durağan",
      "Erfelek",
      "Gerze",
      "Merkez",
      "Saraydüzü",
      "Türkeli",
    ],
  },
  {
    id: 58,
    name: "Sivas",
    districts: [
      "Akıncılar",
      "Altınyayla",
      "Divriği",
      "Doğanşar",
      "Gemerek",
      "Gölova",
      "Gürün",
      "Hafik",
      "İmranlı",
      "Kangal",
      "Koyulhisar",
      "Merkez",
      "Suşehri",
      "Şarkışla",
      "Ulaş",
      "Yıldızeli",
      "Zara",
    ],
  },
  {
    id: 59,
    name: "Tekirdağ",
    districts: [
      "Çerkezköy",
      "Çorlu",
      "Ergene",
      "Hayrabolu",
      "Kapaklı",
      "Malkara",
      "Marmaraereğlisi",
      "Muratlı",
      "Saray",
      "Süleymanpaşa",
      "Şarköy",
    ],
  },
  {
    id: 60,
    name: "Tokat",
    districts: [
      "Almus",
      "Artova",
      "Başçiftlik",
      "Erbaa",
      "Merkez",
      "Niksar",
      "Pazar",
      "Reşadiye",
      "Sulusaray",
      "Turhal",
      "Yeşilyurt",
      "Zile",
    ],
  },
  {
    id: 61,
    name: "Trabzon",
    districts: [
      "Akçaabat",
      "Araklı",
      "Arsin",
      "Beşikdüzü",
      "Çarşıbaşı",
      "Çaykara",
      "Dernekpazarı",
      "Düzköy",
      "Hayrat",
      "Köprübaşı",
      "Maçka",
      "Of",
      "Ortahisar",
      "Sürmene",
      "Şalpazarı",
      "Tonya",
      "Vakfıkebir",
      "Yomra",
    ],
  },
  {
    id: 62,
    name: "Tunceli",
    districts: [
      "Çemişgezek",
      "Hozat",
      "Mazgirt",
      "Merkez",
      "Nazımiye",
      "Ovacık",
      "Pertek",
      "Pülümür",
    ],
  },
  {
    id: 63,
    name: "Şanlıurfa",
    districts: [
      "Akçakale",
      "Birecik",
      "Bozova",
      "Ceylanpınar",
      "Eyyübiye",
      "Halfeti",
      "Haliliye",
      "Harran",
      "Hilvan",
      "Karaköprü",
      "Siverek",
      "Suruç",
      "Viranşehir",
    ],
  },
  {
    id: 64,
    name: "Uşak",
    districts: ["Banaz", "Eşme", "Karahallı", "Merkez", "Sivaslı", "Ulubey"],
  },
  {
    id: 65,
    name: "Van",
    districts: [
      "Bahçesaray",
      "Başkale",
      "Çaldıran",
      "Çatak",
      "Edremit",
      "Erciş",
      "Gevaş",
      "Gürpınar",
      "İpekyolu",
      "Muradiye",
      "Özalp",
      "Saray",
      "Tuşba",
    ],
  },
  {
    id: 66,
    name: "Yozgat",
    districts: [
      "Akdağmadeni",
      "Aydıncık",
      "Boğazlıyan",
      "Çandır",
      "Çayıralan",
      "Çekerek",
      "Kadışehri",
      "Merkez",
      "Saraykent",
      "Sarıkaya",
      "Sorgun",
      "Şefaatli",
      "Yenifakılı",
      "Yerköy",
    ],
  },
  {
    id: 67,
    name: "Zonguldak",
    districts: ["Alaplı", "Çaycuma", "Devrek", "Ereğli", "Gökçebey", "Kilimli", "Kozlu", "Merkez"],
  },
  {
    id: 68,
    name: "Aksaray",
    districts: [
      "Ağaçören",
      "Eskil",
      "Gülağaç",
      "Güzelyurt",
      "Merkez",
      "Ortaköy",
      "Sarıyahşi",
      "Sultanhanı",
    ],
  },
  {
    id: 69,
    name: "Bayburt",
    districts: ["Aydıntepe", "Demirözü", "Merkez"],
  },
  {
    id: 70,
    name: "Karaman",
    districts: ["Ayrancı", "Başyayla", "Ermenek", "Kazımkarabekir", "Merkez", "Sarıveliler"],
  },
  {
    id: 71,
    name: "Kırıkkale",
    districts: [
      "Bahşılı",
      "Balışeyh",
      "Çelebi",
      "Delice",
      "Karakeçili",
      "Keskin",
      "Merkez",
      "Sulakyurt",
      "Yahşihan",
    ],
  },
  {
    id: 72,
    name: "Batman",
    districts: ["Beşiri", "Gercüş", "Hasankeyf", "Kozluk", "Merkez", "Sason"],
  },
  {
    id: 73,
    name: "Şırnak",
    districts: ["Beytüşşebap", "Cizre", "Güçlükonak", "İdil", "Merkez", "Silopi", "Uludere"],
  },
  {
    id: 74,
    name: "Bartın",
    districts: ["Amasra", "Kurucaşile", "Merkez", "Ulus"],
  },
  {
    id: 75,
    name: "Ardahan",
    districts: ["Çıldır", "Damal", "Göle", "Hanak", "Merkez", "Posof"],
  },
  {
    id: 76,
    name: "Iğdır",
    districts: ["Aralık", "Karakoyunlu", "Merkez", "Tuzluca"],
  },
  {
    id: 77,
    name: "Yalova",
    districts: ["Altınova", "Armutlu", "Çınarcık", "Çiftlikköy", "Merkez", "Termal"],
  },
  {
    id: 78,
    name: "Karabük",
    districts: ["Eflani", "Eskipazar", "Merkez", "Ovacık", "Safranbolu", "Yenice"],
  },
  {
    id: 79,
    name: "Kilis",
    districts: ["Elbeyli", "Merkez", "Musabeyli", "Polateli"],
  },
  {
    id: 80,
    name: "Osmaniye",
    districts: ["Bahçe", "Düziçi", "Hasanbeyli", "Kadirli", "Merkez", "Sumbas", "Toprakkale"],
  },
  {
    id: 81,
    name: "Düzce",
    districts: [
      "Akçakoca",
      "Cumayeri",
      "Çilimli",
      "Gölyaka",
      "Gümüşova",
      "Kaynaşlı",
      "Merkez",
      "Yığılca",
    ],
  },
];

// Tüm şehir isimlerini getir — plaka sırasında döner (yukarıdaki nota bak).
export function getAllCities(): string[] {
  return TURKEY_CITIES.map((city) => city.name);
}

// Şehir ID'sine göre şehir bilgisini getir
export function getCityById(id: number): City | undefined {
  return TURKEY_CITIES.find((city) => city.id === id);
}

// Şehir ismine göre şehir bilgisini getir
export function getCityByName(name: string): City | undefined {
  return TURKEY_CITIES.find((city) => city.name.toLowerCase() === name.toLowerCase());
}

// Şehir ismine göre ilçeleri getir
export function getDistrictsByCity(cityName: string): string[] {
  const city = getCityByName(cityName);
  return city?.districts || [];
}

// Şehir ve ilçe bilgisini doğrula
export function isValidCityDistrict(cityName: string, districtName: string): boolean {
  const districts = getDistrictsByCity(cityName);
  return districts.some((d) => d.toLowerCase() === districtName.toLowerCase());
}

// Popüler tatil bölgeleri (öne çıkan şehirler)
export const POPULAR_HOLIDAY_CITIES = [
  "Antalya",
  "Muğla",
  "İzmir",
  "Aydın",
  "İstanbul",
  "Çanakkale",
  "Balıkesir",
  "Mersin",
  "Trabzon",
  "Nevşehir",
];

// Popüler tatil ilçeleri
export const POPULAR_HOLIDAY_DISTRICTS: Record<string, string[]> = {
  Antalya: ["Kaş", "Kemer", "Alanya", "Manavgat", "Serik"],
  Muğla: ["Bodrum", "Fethiye", "Marmaris", "Datça", "Dalaman", "Köyceğiz"],
  İzmir: ["Çeşme", "Seferihisar", "Foça", "Urla", "Selçuk"],
  Aydın: ["Kuşadası", "Didim", "Söke"],
  Çanakkale: ["Bozcaada", "Gökçeada"],
  Balıkesir: ["Ayvalık", "Edremit", "Erdek"],
};
